var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[(!_vm.isIframe)?_c('NavBar'):_vm._e(),_c('router-view'),(!_vm.isIframe)?_c('Footer'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }